export default __webpack_public_path__ + "baaebd68110a9dc761887a0cfb1d0ba9.jpg";